(() => {
  const money = (cents, currency = 'EUR') => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IE', {
        style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (_) {
      return `€${(cents / 100).toFixed(2)}`;
    }
  };

  const moveBreadcrumbs = () => {
    const breadcrumbs = document.querySelector('[data-ab-breadcrumbs]');
    const main = document.getElementById('MainContent');
    if (breadcrumbs && main && breadcrumbs.parentElement !== main) main.prepend(breadcrumbs);
  };

  const initStickyBuy = () => {
    const productInfo = document.querySelector('product-info');
    const originalButton = productInfo?.querySelector('.product-form__submit');
    if (!productInfo || !originalButton || document.querySelector('.ab-sticky-buy')) return;

    const title = productInfo.querySelector('.product__title h1')?.textContent.trim() || 'AuraBliss gift';
    const bar = document.createElement('div');
    bar.className = 'ab-sticky-buy is-hidden';
    bar.setAttribute('aria-label', 'Quick add to cart');
    bar.innerHTML = `<div class="ab-sticky-buy__details"><span class="ab-sticky-buy__title"></span><span class="ab-sticky-buy__price"></span></div><button class="ab-sticky-buy__button" type="button"></button>`;
    bar.querySelector('.ab-sticky-buy__title').textContent = title;
    document.body.appendChild(bar);

    const stickyButton = bar.querySelector('.ab-sticky-buy__button');
    const stickyPrice = bar.querySelector('.ab-sticky-buy__price');
    let originalVisible = true;
    let footerVisible = false;

    const currentPrice = () => {
      const sale = productInfo.querySelector('.price--on-sale .price-item--sale');
      const regular = productInfo.querySelector('.price__regular .price-item--regular');
      return (sale || regular || productInfo.querySelector('.price-item'))?.textContent.trim() || '';
    };

    const sync = () => {
      const label = originalButton.querySelector('span')?.textContent.trim() || originalButton.textContent.trim() || 'Add to cart';
      stickyButton.textContent = label;
      stickyButton.disabled = originalButton.disabled || originalButton.getAttribute('aria-disabled') === 'true';
      stickyPrice.textContent = currentPrice();
    };

    const updateVisibility = () => bar.classList.toggle('is-hidden', originalVisible || footerVisible);
    stickyButton.addEventListener('click', () => {
      sync();
      if (!stickyButton.disabled) originalButton.click();
    });

    if ('IntersectionObserver' in window) {
      const buttonObserver = new IntersectionObserver((entries) => {
        originalVisible = entries[0]?.isIntersecting ?? false;
        updateVisibility();
      }, { threshold: 0.12 });
      buttonObserver.observe(originalButton);

      const footer = document.querySelector('.ab-footer');
      if (footer) {
        const footerObserver = new IntersectionObserver((entries) => {
          footerVisible = entries[0]?.isIntersecting ?? false;
          updateVisibility();
        }, { threshold: 0.05 });
        footerObserver.observe(footer);
      }
    } else {
      originalVisible = false;
      updateVisibility();
    }

    let syncTimer;
    const infoObserver = new MutationObserver(() => {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(sync, 60);
    });
    infoObserver.observe(productInfo, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
    sync();
  };

  const refineCartLinks = () => {
    const destinations = [
      ['cart-drawer .cart-drawer__empty-content .button', 'Discover Wax Bouquets'],
      ['cart-items .title-wrapper-with-link .underlined-link', 'Continue shopping'],
      ['cart-items .cart__warnings .button', 'Discover Wax Bouquets']
    ];

    destinations.forEach(([selector, label]) => {
      document.querySelectorAll(selector).forEach((link) => {
        link.getAttribute("href") !== "/collections/handcrafted-wax-bouquets" &&
  link.setAttribute("href", "/collections/handcrafted-wax-bouquets");

link.textContent !== label &&
  (link.textContent = label);

link.classList.contains("ab-cart-secondary-link") ||
  link.classList.add("ab-cart-secondary-link");
      });
    });
  };

  const shippingThreshold = 4500;
  let cartTimer;
  let cartRequest = 0;

  const progressMarkup = (cart) => {
    const total = Number(cart.total_price || 0);
    const currency = cart.currency || 'EUR';
    const remaining = Math.max(shippingThreshold - total, 0);
    const progress = Math.min((total / shippingThreshold) * 100, 100);
    const message = remaining === 0
      ? '<strong>Free delivery unlocked for Ireland</strong>'
      : `Add <strong>${money(remaining, currency)}</strong> more for free delivery in Ireland`;
    return `<div class="ab-shipping-progress__top"><span>${message}</span><span>${Math.round(progress)}%</span></div><div class="ab-shipping-progress__track" aria-hidden="true"><span class="ab-shipping-progress__bar" style="width:${progress}%"></span></div><div class="ab-shipping-progress__trust">Secure checkout - Handmade in Ireland</div>`;
  };

  const placeProgress = (container, cart) => {
    if (!container) return;
    let node = container.querySelector(':scope > .ab-shipping-progress');
    if (!cart.item_count) {
      node?.remove();
      return;
    }
    if (!node) {
      node = document.createElement('div');
      node.className = 'ab-shipping-progress';
      container.prepend(node);
    }
    const markup = progressMarkup(cart);
    if (node.innerHTML !== markup) node.innerHTML = markup;
  };

  const updateCartProgress = async () => {
    refineCartLinks();
    const requestId = ++cartRequest;
    try {
      const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (requestId !== cartRequest) return;
      placeProgress(document.querySelector('cart-drawer .drawer__footer'), cart);
      placeProgress(document.querySelector('#main-cart-footer .cart__blocks'), cart);
      refineCartLinks();
    } catch (_) {}
  };

  const queueCartProgress = () => {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(updateCartProgress, 220);
  };

  const observeCart = () => {
    ['cart-drawer-items', 'cart-items'].forEach((selector) => {
      const target = document.querySelector(selector);
      if (!target) return;
      new MutationObserver(() => {
        refineCartLinks();
        queueCartProgress();
      }).observe(target, { childList: true, subtree: true, characterData: true });
    });
    document.addEventListener('click', (event) => {
      if (event.target.closest('.quantity__button, cart-remove-button, .product-form__submit, .quick-add__submit')) {
        setTimeout(queueCartProgress, 350);
      }
    });
    document.addEventListener('change', (event) => {
      if (event.target.matches('.cart-quantity .quantity__input, .cart-item__quantity .quantity__input')) setTimeout(queueCartProgress, 300);
    });
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, queueCartProgress);
      }
    } catch (_) {}
    refineCartLinks();
    queueCartProgress();
  };

  const init = () => {
    moveBreadcrumbs();
    initStickyBuy();
    observeCart();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

(() => {
  const findCustomColourField = (form) => {
    if (!form?.id) return null;

    const sectionId = form.id.startsWith('product-form-')
      ? form.id.slice('product-form-'.length)
      : '';

    if (sectionId) {
      const byId = document.getElementById(`CustomColour-${sectionId}`);
      if (byId) return byId;
    }

    return Array.from(document.querySelectorAll('textarea[name="properties[Custom Colour Request]"]'))
      .find((field) => field.form === form || field.getAttribute('form') === form.id) || null;
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('product-form form[data-type="add-to-cart-form"]')) return;

    const textarea = findCustomColourField(form);
    if (!textarea || !textarea.required) return;

    if (textarea.value.trim()) {
      textarea.setCustomValidity('');
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    const details = textarea.closest('details');
    if (details) {
      details.style.display = 'block';
      details.open = true;
    }

    textarea.setAttribute('aria-required', 'true');
    textarea.setCustomValidity('Please enter the colours you would like.');
    textarea.reportValidity();
    textarea.focus();
  }, true);

  document.addEventListener('input', (event) => {
    const textarea = event.target;
    if (!(textarea instanceof HTMLTextAreaElement)) return;
    if (textarea.name !== 'properties[Custom Colour Request]') return;
    if (textarea.value.trim()) textarea.setCustomValidity('');
  });
})();
